module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAASCAYAAABSO15qAAAA8ElEQVR42mL8//8/Aw5gAsT2QMwGxGeAeC8Q/8NQBTIADfMB8fr/mOA0ECugq8dmwMb/uMEtIObEZ4DFf8IgC1kPE5qPnBkIAwdkDroBbEQYwIbPgAtEGHAJXyywAvENPP7/AsQyhGJBB4gf49Dsha6eEUdCEgDiTGhCYocmpMlA/AhdIboBwkCcA8QeQCwPxBxQ8d9A/BSI9wPxVCC+hy0M/IH4HRHp4DcQF6OHgTcQ//lPGiiFhQEX0CG3gFiagTQA8pYOKB34kqEZBFiBOAlkgCkD+cAEZMBfCgz4AwpAKSA+DsR/SQzE+0BsChBgAPQL5lO3EviqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/ren.png
// module id = 3B9q
// module chunks = 1